// ISO 3166-1 alpha-2 codes. Names are generated via Intl.DisplayNames rather
// than a hand-maintained translation table, so every supported UI language
// gets correct names and correct alphabetical order (via Intl.Collator) for
// free. Codes are only ever used to look up/sort names here - the value
// actually submitted and stored is the localized name string, matching how
// every other option field in this app (title, specialization) already
// works, so no normalization step is needed elsewhere.
const PINNED_CODES = ['AT', 'DE', 'US'];

const OTHER_CODES = [
  'AF', 'AL', 'DZ', 'AD', 'AO', 'AG', 'AR', 'AM', 'AU', 'AZ',
  'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ', 'BT', 'BO', 'BA', 'BW', 'BR', 'BN', 'BG', 'BF', 'BI',
  'CV', 'KH', 'CM', 'CA', 'CF', 'TD', 'CL', 'CN', 'CO', 'KM', 'CG', 'CD', 'CR', 'CI', 'HR', 'CU', 'CY', 'CZ',
  'DK', 'DJ', 'DM', 'DO',
  'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'SZ', 'ET',
  'FJ', 'FI', 'FR',
  'GA', 'GM', 'GE', 'GH', 'GR', 'GD', 'GT', 'GN', 'GW', 'GY',
  'HT', 'HN', 'HU',
  'IS', 'IN', 'ID', 'IR', 'IQ', 'IE', 'IL', 'IT',
  'JM', 'JP', 'JO',
  'KZ', 'KE', 'KI', 'KP', 'KR', 'KW', 'KG',
  'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU',
  'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MR', 'MU', 'MX', 'FM', 'MD', 'MC', 'MN', 'ME', 'MA', 'MZ', 'MM',
  'NA', 'NR', 'NP', 'NL', 'NZ', 'NI', 'NE', 'NG', 'MK', 'NO',
  'OM',
  'PK', 'PW', 'PA', 'PG', 'PY', 'PE', 'PH', 'PL', 'PT',
  'QA',
  'RO', 'RU', 'RW',
  'KN', 'LC', 'VC', 'WS', 'SM', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SK', 'SI', 'SB', 'SO', 'ZA', 'SS', 'ES', 'LK', 'SD', 'SR', 'SE', 'CH', 'SY',
  'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TO', 'TT', 'TN', 'TR', 'TM', 'TV',
  'UG', 'UA', 'AE', 'GB', 'UY', 'UZ',
  'VU', 'VA', 'VE', 'VN',
  'YE',
  'ZM', 'ZW',
];

const nameFor = (code, displayNames) => (displayNames ? displayNames.of(code) : null) || code;

// Returns [{code, name}] with Austria/Germany/USA first (in that order),
// then every other country alphabetized in the given language.
export const getCountryOptions = (language) => {
  const locale = language === 'de' ? 'de' : 'en';
  let displayNames;
  try {
    displayNames = new Intl.DisplayNames([locale], { type: 'region' });
  } catch (e) {
    displayNames = null;
  }

  const pinned = PINNED_CODES.map((code) => ({ code, name: nameFor(code, displayNames) }));

  const collator = new Intl.Collator(locale, { sensitivity: 'base' });
  const rest = OTHER_CODES
    .map((code) => ({ code, name: nameFor(code, displayNames) }))
    .sort((a, b) => collator.compare(a.name, b.name));

  return [...pinned, ...rest];
};
